import { useEffect, useMemo, useRef, useState } from "react";

import { Loader } from "@bracket/react-loader";

import { ChooseWallet } from "./ChooseWallet";
import { ConnectionHUD } from "./ConnectionHUD";

import { useLegalStore } from "@stores/legal";
import { usePointsStore } from "@stores/points";

import "./ConnectionManager.scss";
import { useAccount, useChainId } from "wagmi";
import { InviteEntry } from "@sections";
import { PartnerBar, useModalizeStore } from "components";
import { useEscrowStore } from "@stores/escrow";
export const ConnectionManager = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const wasConnected = useRef(false);
  const chainId = useChainId();
  const { chain, isConnected, address } = useAccount();
  const goodChainSelected = useMemo(
    () => chainId === chain?.id,
    [chainId, chain]
  );

  const {
    initialized: pointsInitialized,
    user_code_applied,
    user_code_valid,
    user_code_applying,
    bindWalletToCode,
    user_referred,
    user_referral_submitted,
    initialize: initializePoints,
  } = usePointsStore();

  const {
    initialized: legalIniitalized,
    initialize: legalInitialize,
    country_lock,
    account_lock,
  } = useLegalStore();

  const {
    initialize: initializeEscrowStore,
    initialized: escrowInitialized,
    deinitialize: deinitializeEscrow,
  } = useEscrowStore();

  const classes = [
    "conn-man",
    legalIniitalized && !country_lock && !account_lock ? "locked" : null,
  ]
    .filter((v) => v)
    .join(" ");

  useEffect(() => {
    const init = async () => {
      await legalInitialize();
    };
    init();
  }, []);

  useEffect(() => {
    if (
      address &&
      !user_code_applied &&
      user_code_valid &&
      !user_code_applying
    ) {
      (async () => {
        bindWalletToCode(address);
      })();
      return;
    }
  }, [user_code_valid, address, user_referred, user_referral_submitted]);

  useEffect(() => {
    if (!pointsInitialized && address) {
      (async () => {
        await initializePoints();
      })();
    }
  }, [pointsInitialized, address]);

  useEffect(() => {
    if (address && goodChainSelected && !escrowInitialized) {
      setTimeout(() => initializeEscrowStore(), 1500);
    }
  }, [address, goodChainSelected]);

  useEffect(() => {
    if (!goodChainSelected && address) {
      console.log("wrong chain");
    }
  }, [goodChainSelected]);

  useEffect(() => {
    if (!wasConnected.current && isConnected) {
      wasConnected.current = isConnected;
    }

    if (wasConnected.current && !isConnected) {
      console.log("deinitialize escrow!");
      wasConnected.current = isConnected;
      deinitializeEscrow();
    }
  }, [isConnected]);

  if (!legalIniitalized) return <Loader />;

  const displayConnectModal = !address || !isConnected || !goodChainSelected;

  return (
    <>
      <section className={classes}>
        {displayConnectModal && <ChooseWallet />}
        {!displayConnectModal && <ConnectionHUD />}
      </section>
      {!displayConnectModal && <>{children}</>}
    </>
  );
};
